/**
 * localStorage persistence layer for user-defined custom buffs and debuffs.
 */

import { BuffOrDebuff } from '../types';

const KEY_CUSTOM_BUFFS = 'frostgrave:custom-buffs';

function readAll(): BuffOrDebuff[] {
  try {
    const raw = localStorage.getItem(KEY_CUSTOM_BUFFS);
    return raw ? (JSON.parse(raw) as BuffOrDebuff[]) : [];
  } catch {
    return [];
  }
}

function writeAll(buffs: BuffOrDebuff[]): void {
  localStorage.setItem(KEY_CUSTOM_BUFFS, JSON.stringify(buffs));
}

export const customBuffService = {
  getAll(): BuffOrDebuff[] {
    return readAll();
  },

  create(data: Omit<BuffOrDebuff, 'id'>): BuffOrDebuff {
    const buff: BuffOrDebuff = { ...data, id: `custom_${crypto.randomUUID()}` };
    writeAll([...readAll(), buff]);
    return buff;
  },

  update(id: string, data: Partial<Omit<BuffOrDebuff, 'id'>>): BuffOrDebuff | null {
    const all = readAll();
    const index = all.findIndex((buff) => buff.id === id);
    if (index === -1) return null;
    const updated: BuffOrDebuff = { ...all[index], ...data, id };
    const next = [...all];
    next[index] = updated;
    writeAll(next);
    return updated;
  },

  delete(id: string): void {
    writeAll(readAll().filter((buff) => buff.id !== id));
  },

  replaceAll(buffs: BuffOrDebuff[]): void {
    writeAll(buffs);
  },
};